import axios from 'axios';
import {jwtDecode} from 'jwt-decode';

let accessToken = null;
let refreshPromise = null;
let sessionExpiredHandler = null;

const authApi = axios.create({
    baseURL: '/api/auth',
    withCredentials: true,
});

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
    accessToken = token || null;
    return accessToken;
};

export const clearAccessToken = () => {
    accessToken = null;
};

export const isAccessTokenExpired = (token) => {
    if (!token) {
        return true;
    }

    try {
        const decodedToken = jwtDecode(token);
        return !decodedToken.exp || decodedToken.exp * 1000 <= Date.now();
    } catch {
        return true;
    }
};

export const setSessionExpiredHandler = (handler) => {
    sessionExpiredHandler = handler;
};

export const notifySessionExpired = () => {
    clearAccessToken();
    if (sessionExpiredHandler) {
        sessionExpiredHandler();
    }
};

export const loginWithPassword = async (email, password) => {
    const response = await authApi.post('/login', {email, password});
    const data = response.data;
    if (data.requiresMfa || data.requiresMfaEnrolment) {
        return data;
    }
    setAccessToken(data.token);
    return data;
};

export const refreshAccessToken = async () => {
    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = authApi
        .post('/refresh', {})
        .then((response) => {
            setAccessToken(response.data.token);
            return response.data.token;
        })
        .catch((error) => {
            clearAccessToken();
            throw error;
        })
        .finally(() => {
            refreshPromise = null;
        });

    return refreshPromise;
};

export const logoutSession = async () => {
    try {
        await authApi.post('/logout', {});
    } finally {
        clearAccessToken();
    }
};
